import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { idRequiredValidator } from '@core/validators/id-required.validator';

@Component({
  selector: 'app-dialog-link-region',
  templateUrl: './dialog-link-region.component.html',
  styleUrls: ['./dialog-link-region.component.scss']
})
export class DialogLinkRegionComponent implements OnInit {

  regionForm: UntypedFormGroup;

  constructor(
    private _dialogRef: MatDialogRef<DialogLinkRegionComponent>,
    private _formBuilder: UntypedFormBuilder,

  ) { }

  ngOnInit(): void {

    this.regionForm = this._formBuilder.group(
      {
        regionControl: ['', [Validators.required, idRequiredValidator]],
      }
    )
  }

  select(): void {
    this._dialogRef.close(this.regionForm.get('regionControl').value);
  }

}
